import { ReactElement, useCallback } from 'react';
import { useAppNavigation } from 'contexts/navigation';
import { useProjectId } from 'store/project';

type DocumentationFileNavigationActionRenderProps = {
  canNavigate: boolean;
  navigateToDocumentationFile: () => void;
};

type DocumentationFileNavigationActionProps = {
  documentationId?: string;
  /** Opens this version of the documentation instead of its current one. */
  versionId?: string;
  children: (
    props: DocumentationFileNavigationActionRenderProps
  ) => ReactElement | null;
};

export function DocumentationFileNavigationAction({
  documentationId,
  versionId,
  children,
}: DocumentationFileNavigationActionProps): ReactElement | null {
  const projectId = useProjectId();
  const { goToDocumentationFile } = useAppNavigation();

  const canNavigate = Boolean(projectId && documentationId);

  const navigateToDocumentationFile = useCallback((): void => {
    if (!projectId || !documentationId) {
      return;
    }

    goToDocumentationFile(projectId, documentationId, {
      replace: true,
      versionId,
    });
  }, [documentationId, goToDocumentationFile, projectId, versionId]);

  return children({ canNavigate, navigateToDocumentationFile });
}
